// In-memory cache of the Assistant Conversations list UI state.
// Survives client-side navigation (open a conversation -> press Back) so the
// filters / pagination / scroll position are restored on remount. Resets on a
// full page reload, mirroring how the screen behaves on a fresh visit.

const DEFAULT_LIST_STATE = {
  filters: null,
  current: 1,
  pageSize: 10,
  scrollY: 0,
};

let listState = { ...DEFAULT_LIST_STATE };

export const getListState = () => listState;

export const setListState = (partial) => {
  listState = { ...listState, ...partial };
};

export const resetListState = () => {
  listState = { ...DEFAULT_LIST_STATE };
};

export default { getListState, setListState, resetListState };
